import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InvalidProduct } from 'src/app/models/cart';

declare var $: any;

@Component({
  selector: 'app-product-success-upload',
  templateUrl: './product-success-upload.component.html',
  styleUrls: ['./product-success-upload.component.css']
})
export class ProductSuccessUploadComponent implements OnInit {
  public products: InvalidProduct[] = [];
  public productTotal: number;
  public isSuccess = false;
  public isEmpty = true;
  public isLoading = false;
  public modalProductSuccessUploaded = 'modal-product-success-uploaded';

  constructor(private router: Router) { }

  ngOnInit() {
  }

  public showLoader(): void {
    this.show();
    this.isLoading = true;
  }

  public removeLoader(): void {
    this.hide();
    this.isLoading = false;
  }

  public showWithData(productList: InvalidProduct[], isSuccess: boolean, message = ''): void {
    this.show();
    if (isSuccess === true) {
      if (productList != null && productList.length > 0) {
        this.products = productList;
        this.productTotal = productList.length;

        this.isEmpty = false;
      }

      this.isLoading = false;
      this.isSuccess = isSuccess;
    } else {
      this.isLoading = false;
    }
  }

  public show(): void {
    $('#' + this.modalProductSuccessUploaded).modal('show');
  }

  public hide(): void {
    $('#' + this.modalProductSuccessUploaded).modal('hide');
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  public goToCart(): void {
    this.router.navigate(['/cart']);
  }
}
